import ConnectedCards from './ConnectedCards'

export default ConnectedCards
